
/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { Injectable, signal } from '@angular/core';
import { Params } from '@angular/router';
import { uuid } from '@src/app/model/abstract-object';
import { NavOption } from '@src/app/model/sys/navOption';
import { FormConfig } from "@src/app/shared/form/FormConfig";
export interface NewButtonState {
    actionName?: string;
    link?: string;
    showButton: boolean;
    actionParms?: Params;
    options?: NavOption[];
}
@Injectable({
    providedIn: 'root'
})
export class NewButtonService {

    /*
     * Written by whichever page the user has landed on, read by the single <app-new-button> in the
     * nav bar. A signal rather than an observable because the write lands mid-navigation, after the
     * nav bar has been checked for this cycle: a signal write schedules its own refresh, where a
     * plain binding raised ExpressionChangedAfterItHasBeenChecked.
     */
    readonly state = signal<NewButtonState>({ actionName: '', link: '', showButton: false, options: [] });

    public setupButtonFromConfig(config: FormConfig, forceTeam: uuid = null) {
        this.setupButton(config.title, config.pathNew(), config.allowNew, config.newOptions, forceTeam);
    }

    public setupButtonWithParms(action: string, link: string, parms: Params) {
        const actionName = $localize`New ${action}`;
        this.state.set({ actionName, link, showButton: true, options: [], actionParms: parms });
    }

    public setupButton(action: string, link: string, showButton = true, options: NavOption[] = [], forceTeam: uuid = null) {
        const actionName = $localize`New ${action}`;
        for (const navo of options) {
            if (!navo.params) {
                navo.params = {};
            }
        }
        const actionParms = forceTeam ? { _forceTeam: forceTeam } : {};
        this.state.set({ actionName, link, showButton, options, actionParms });
    }

    clear() {
        this.state.set({ showButton: false, options: [] });
    }
}
